import { Decoder } from 'jsonous';
import { activeProgramModuleDecoder } from '../../../ProgramStore/Decoders';
import { resourceDecoder } from '../../../Resource/Decoders';
import { AutoLaunchableResource } from './Types';

export const autoLaunchableDecoder: Decoder<AutoLaunchableResource> = resourceDecoder(
  activeProgramModuleDecoder,
);
